export default "__VITE_ASSET__BTr2rwSO__"